import { render, staticRenderFns } from "./EditContactData.vue?vue&type=template&id=4182c45d&"
import script from "./EditContactData.vue?vue&type=script&lang=js&"
export * from "./EditContactData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports